import store from '@/store';

export default async function outlook() {
  store.commit('auth/setIsOutlookPage', true, {
    root: true,
  });
}
